/**
 * Indonesian rupiah.
 */
export var IDR = {
  code: 'IDR',
  base: 10,
  exponent: 2
};